import styled from 'styled-components';
import { spacing } from '~/constants/spacing';

export const ParagraphsContainer = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: disc;
  color: white;
  gap: ${spacing.md};
`;

export const Paragraph = styled.li``;

export const ResponsiveImageWrapper = styled.div`
  @media (max-width: 750px) {
    img {
      max-width: 100% !important;
      height: 200px !important;
      object-fit: cover;
    }
  }
`;